import styles from "./Deal.module.css";

const Dealitem = ({item}) => {
    const {imgUrl, place, title, point, price, discount, pricedeal, another} = item;
    const path = process.env.PUBLIC_URL;
    return (
    
        <div>
            <a href="#">
            <div className={styles.dealbox}>
           <div className= {styles.deal_img}>
            <img src={imgUrl} alt={place} />
          </div> 
          {/* <img src={`${path}/deal1.jpg`} alt={place} /> */}
          <div className={styles.textbox}>
            <h4>{place}</h4>
            <h2>{title}</h2>
            <h5>{point}</h5>
            <div className={styles.price}>{price}</div>
            <div className={styles.price_main}>
            <p className={styles.num}>{another}</p>
            <div className={styles.price_deal}><span>{discount}</span> {pricedeal}</div></div>
          </div>
        </div>
        </a>
        </div>
    );
};

export default Dealitem;